import AspectRatio from 'components/Common/AspectRatio'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'components/Common/Loading/TextLoadingBox'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Tile = styled(Pane)`
  ${mediaQueryUp.md} {
    display: grid;
    grid-template-columns: 67% 1fr;
  }
`

const Content = styled.div`
  position: relative;
  padding: ${rem(20)} ${rem(24)};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${rem(16)};
`

const TopDetailSegment = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  gap: ${rem(16)};
`

const ImageSection = styled.div`
  display: grid;
  gap: ${rem(4)};
`

const AdditionalImages = styled.div`
  display: none;

  ${mediaQueryUp.md} {
    display: grid;
    height: ${rem(75)};
    grid-template-columns: repeat(5, 1fr);
    gap: ${rem(4)};
  }
`

const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 50%;
  margin-left: auto;
`

const BottomSection = styled(VerticalSpacer)`
`

function SearchOfferTileLoadingSkeleton() {
  return (<Tile type="clean">
    <ImageSection>
      <AspectRatio xs="16:9">
        <LoadingBox floating />
      </AspectRatio>
      <AdditionalImages>
        <LoadingBox />
        <LoadingBox />
        <LoadingBox />
        <LoadingBox />
        <LoadingBox />
      </AdditionalImages>
    </ImageSection>
    <Content>
      <TopDetailSegment>
        <TextLoadingBox style={{ width: rem(140) }} size="body-medium"/>
        <div style={{ minWidth: '50%' }}>
          <TextLoadingBox size="heading-six" />
          <TextLoadingBox size="subtitle-three" />
        </div>
        <div>
          <TextLoadingBox size="body-medium" lines={6} />
        </div>
      </TopDetailSegment>
      <BottomSection gap={16}>
        <PriceSection>
          <TextLoadingBox size="caption-small" />
          <TextLoadingBox size="heading-six" />
          <TextLoadingBox size="caption-small" />
        </PriceSection>
      </BottomSection>
    </Content>
  </Tile>)
}

export default React.memo(SearchOfferTileLoadingSkeleton)
